import { render, staticRenderFns } from "./screenshot-carousel.vue?vue&type=template&id=87ffc692&scoped=true"
import script from "./screenshot-carousel.vue?vue&type=script&lang=js"
export * from "./screenshot-carousel.vue?vue&type=script&lang=js"
import style0 from "./screenshot-carousel.vue?vue&type=style&index=0&id=87ffc692&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87ffc692",
  null
  
)

export default component.exports